import { Button, Divider, Grid, MenuItem, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useAxios } from "../../../../hooks";
import { Autocomplete, TextField } from "../../../../components";
import FormDisplay from "../../../actions/details components/FormDisplay";
import {
  actionObject,
  objectFromFormData,
} from "../../../actions/details components/actionObject";
import { Formik } from "formik";

export default function Actions({
  openDrawer,
  actions,
  parentFormik,
  setEditAction,
  setOpenDrawer,
  formikProps,
  setNewAction,
}) {
  const axios = useAxios();

  const [temp, setTemp] = useState("");
  const [fields, setFields] = useState([]);
  const [actionType, setActionType] = useState([]);
  const [formData, setFormData] = useState(actionObject);

  const { activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    axios({
      url: "/workflow/action-type/" + activeBot.ID,
    }).then((response) => {
      if (response.status) {
        setActionType(response.data);
      }
    });

    axios({
      url:
        "/custom_fields/get_fields_for_agent?agent_id=" +
        activeBot.ID +
        "&is_active=1",
      method: "GET",
    }).then(async (response) => {
      if (response.status) {
        let filterColumns = [
          {
            name: "name",
            label: "Name",
            dataType: "string",
          },
          {
            name: "email",
            label: "Email",
            dataType: "string",
          },
          {
            name: "phone",
            label: "Phone",
            dataType: "string",
          },
          {
            name: "created_by",
            label: "Created By",
            dataType: "string",
          },
        ];
        for await (let field of response.data) {
          filterColumns.push({
            name: field.name,
            label: field.label,
            dataType: field.value_type,
            ...(field.control_id === "61dd2dfa1fb38be82e077ed8" && {
              options: field.options,
            }),
          });
        }
        setFields(filterColumns);
      }
    });
  }, [axios, activeBot.ID]);

  return (
    <Fragment>
      <Grid item xs={12}>
        <Typography variant="h5">Add Actions to workflow</Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography color={"primary"} variant="h6">
          Use already existing Action
        </Typography>
      </Grid>

      {openDrawer.action === "yes" && (
        <Grid item xs={3}>
          <Autocomplete
            name="actions"
            label="Select Yes Action"
            formikProps={formikProps}
            options={actions}
            defaults={{
              primaryKey: "_id",
              displayLabel: "action_name",
            }}
            onChange={(_, value, type) =>
              handleChangeActions(value, type, "actions")
            }
          />
        </Grid>
      )}

      {openDrawer.action === "no" && (
        <Grid item xs={3}>
          <Autocomplete
            name="noActions"
            label="Select No Action"
            formikProps={formikProps}
            options={actions}
            defaults={{
              primaryKey: "_id",
              displayLabel: "action_name",
            }}
            onChange={(_, value, type) =>
              handleChangeActions(value, type, "noActions")
            }
          />
        </Grid>
      )}

      <Grid item xs={12} textAlign={"end"}>
        <Button
          onClick={() => handleAddAction()}
          variant="contained"
          color="primary"
        >
          Add Action
        </Button>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography color={"primary"} variant="h6">
          Create new action
        </Typography>
      </Grid>

      <Formik
        enableReinitialize
        initialValues={formData}
        validateOnMount
        onSubmit={(formData, { setSubmitting }) => {
          let url = "/workflow/action/" + activeBot.ID;
          if (formData.actionID) {
            url =
              "/workflow/action/" +
              activeBot.ID +
              "?action_id=" +
              formData.actionID;
          }
          axios({
            url: url,
            method: "POST",
            data: objectFromFormData(formData),
            disableRedirect: true,
          }).then((response) => {
            if (response.status) {
              setNewAction(response.data?.action_id);
              if (formData.actionFlow === "yes") {
                parentFormik.setValues((prev) => ({
                  ...prev,
                  actions: response.data?.action_id,
                  selectedActionName: formData.actionName,
                  actionExist: true,
                }));
              }

              if (formData.actionFlow === "no") {
                parentFormik.setValues((prev) => ({
                  ...prev,
                  noActions: response.data?.action_id,
                  selectedActionName: formData.actionName,
                  actionExist: true,
                }));
              }

              setOpenDrawer({ state: false });
            }
            setSubmitting(false);
          });
        }}
      >
        {(drawerFormik) => (
          <Fragment>
            <Grid item xs={4}>
              <TextField
                select
                name="actionFlow"
                label="Select Action Flow"
                formikProps={drawerFormik}
              >
                <MenuItem value="yes">Yes Action</MenuItem>
                <MenuItem value="no">No Action</MenuItem>
              </TextField>
            </Grid>

            <FormDisplay
              editState={true}
              fields={fields}
              setTemp={setTemp}
              actionType={actionType}
              formikProps={drawerFormik}
            />

            <Grid item xs={12} />

            <Grid item xs />

            <Grid item textAlign={"end"}>
              <Button variant="outlined" color="primary">
                Clear Form
              </Button>
            </Grid>

            <Grid item>
              <Button
                onClick={drawerFormik.handleSubmit}
                variant="contained"
                color="primary"
              >
                Create Action
              </Button>
            </Grid>
          </Fragment>
        )}
      </Formik>
    </Fragment>
  );

  function handleChangeActions(value, type, key) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [key]: value._id,
        selectedActionName: value.action_name,
      }));
    } else {
      value = {
        _id: "",
        action_name: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [key]: value._id,
        selectedActionName: value.action_name,
      }));
    }
  }

  function handleAddAction() {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      stage: 3,
      actionExist: prevVal.actions.length > 0 ? true : false,
    }));

    setOpenDrawer((prev) => ({
      ...prev,
      state: false,
    }));
  }
}
